<template>
    <div class="down-box">
  
      <div class="price-num">
        价格：<span>{{priceData}}￥</span>
      </div>
  
      <div class="buy-tip">如有需求请联系企业客服</div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        
      }
    },
    props: {
      lectoParams: { default: {} },
      productDetail: { default: {} },
    },
    components: {},
    computed: {
      priceData() {
        let prodPrice = 0;
        const {IsSelected, SkuPrice} = this.lectoParams;
        const {MinPrice, MaxPrice} = this.productDetail;
        if (IsSelected && SkuPrice) {
            prodPrice = Math.floor(SkuPrice / 100);
        } else {
            if (MinPrice == MaxPrice) {
                prodPrice = Math.floor(MaxPrice / 100);
            } else {
                prodPrice = Math.floor(MinPrice / 100) + '-' + Math.floor(MaxPrice / 100);
            }
        }
        prodPrice = prodPrice.toString().replace('999999','面议');
        return prodPrice;
      }
    },
    methods: {
      
    }
  }
  </script>
  
  <style lang="less" scoped>
  .down-box{
    width: 100%;
    height: 42px;
    background: #F1F1F1;
    display: flex;
    align-items: center;
    font-size: 15px;
    position: relative;
    padding-left: 16px;
  }
  .price-num{
    font-size: 16px;
    span{
        color: red;
        font-weight: bold;
    }
  }
  .buy-tip{
    font-size: 12px;
    color: #606266;
    margin-left: 12px;
  }
  </style>
  
